import styled, { css } from 'styled-components';

import ImageIdFrontGuide from 'images/pictographs/id-front-guide.svg';

const Positioner = styled('div')`
  position: relative;
  right: 0;
  top: 100%;
  bottom: 100%;
  ${({ mirrored }: IdFrontGuideProps) =>
    mirrored &&
    css`
      transform: scale(-1, 1);
    `};
`;

interface IdFrontGuideProps {
  mirrored: boolean;
}

export default function IdFrontGuide({ mirrored = false }: IdFrontGuideProps) {
  return (
    <Positioner data-test='id-front__guide' mirrored={mirrored}>
      <ImageIdFrontGuide />
    </Positioner>
  );
}
